import isHTML from './IsHtml';
import correctAnchorTarget from './correctAnchorTarget';
import decodeHTML from './decodeHTML';
import GlobalVariables from '../GlobalVariables';

/* CHAT-5855 EP showing <img> html tag as plain text on V2 and V3, for both visitor upon refreshing the page and agents can see it as plain text without refreshing.
 * this problem only occur when message contain both Encoded and Decoded html
 * checking if message contain both Encoded and Decoded html then removing Decoded html and rendering Encoded html
 * also corrects anchor tags with no targets */
const cleanInvalidHtml = (html) => {
    html = html || '';
    // Decode the HTML first to decode the special chars like &,# or > signs
    // then remove encoded html
    let decodedHtml = decodeHTML(html);

    /* checking if html contain both Encoded and Decoded html in message */
    if (
        (decodedHtml.match(GlobalVariables.encodedHtmlRegex) ||
            decodedHtml.match(GlobalVariables.scriptTagRegex) ||
            decodedHtml.match(GlobalVariables.styleTagRegex)) &&
        isHTML(decodedHtml)
    ) {
        /* removing decodedHtml from text */
        decodedHtml = decodedHtml.replace(/<[^>]*>/g, '');
    }
    return correctAnchorTarget(decodedHtml);
};
export default cleanInvalidHtml;
